module.exports = __webpack_public_path__ + "img/invest_list1.bb700291.png";